module.exports = __webpack_public_path__ + "static/media/cover_pic@2x.a8d4b8d2.png";